"use client";

import LatestProjectCard from "@/components/hero/latest-project";
import { SmoothScroll } from "@/components/hero/smooth-scroll";
import Clientele from "@/components/hero/clientele";
import Dock from "@/components/ui/dock";
import { VscFiles, VscSmiley } from "react-icons/vsc";
import AboutMe from "@/components/hero/aboutme";
import Services from "@/components/hero/services";
import { useRouter } from "next/navigation";
import Footer from "@/components/ui/footer";
import ImageCarousel from "@/components/ui/carousel";
import PreloaderHero from "@/components/hero/Preloader";

export default function Home() {
  const router = useRouter();

  const items = [
    {
      icon: <VscFiles size={20} />,
      label: "My Works",
      onClick: () => router.push("/projects"),
    },
    {
      icon: <img src="/logo/av.png" alt="Home" className="w-6 h-4" />,
      label: "Home",
      onClick: () => router.push("/"),
    },
    {
      icon: <VscSmiley size={20} />,
      label: "Contact",
      onClick: () => router.push("/contact"),
    },
  ];

  return (
    <>
      {/* Fixed full-screen hero + preloader (z-index handled inside) */}
      <PreloaderHero />

      {/* Spacer: lets the fixed hero be visible first */}
      <div className="h-svh" aria-hidden="true" />

      {/* Scrolling content slides up OVER the hero */}
      <div className="relative z-10 bg-background">
        <div className="grid grid-rows-[auto_1fr_auto] items-center justify-items-center px-4 sm:px-20 py-10 font-[family-name:var(--font-geist-sans)]">
          <main className="flex flex-col items-center sm:items-start w-full max-w-5xl">
            <SmoothScroll />
            <LatestProjectCard />
            <Clientele />
            <ImageCarousel />
            <AboutMe />
            <Services />
            <Footer />
          </main>
        </div>
      </div>

      {/* Dock stays above everything */}
      <div className="relative z-[200]">
        <Dock
          items={items}
          panelHeight={68}
          baseItemSize={50}
          magnification={70}
        />
      </div>
    </>
  );
}
